import { serialize as blob } from './blob';
import { serialize as formData } from './form-data';
import { serialize as buffer } from './buffer';

export default { blob, formData, buffer };
